import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { CacheService } from '../services/cache.service';
import { LoggingMessageService } from '../services/logging-message.service';
import { AuthService } from '../services/auth.service';


@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    private useClientCaching = environment.UseClientCaching;
    private cachingUrls = environment.CachingUrls;

    constructor(private authService: AuthService, private cache: CacheService, private logger: LoggingMessageService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const availableSubs = this.authService.AvailableSubscriptionsString;
        const subscription = this.authService.SelectedSubscription;
        const sub = +subscription;

        this.logger.debug('cache-interceptor', 'intercept', sub, availableSubs, `Cache Intercept running`, '');
        let cachedResponse = null;
        if (this.useClientCaching) {
            const isCaching = this.isCachingUrl(this.cachingUrls, req.url);
            if (isCaching === true) {
                 this.logger.debug('cache-interceptor', 'intercept', sub, availableSubs, `Caching Url detected: ${req.url}`, '');
                const skipCache = this.skipCache(req.url);
                if (!skipCache) {
                     this.logger.debug('cache-interceptor', 'intercept', sub, availableSubs, `Looking for cached response: ${req.url}`, '');
                    cachedResponse = this.cache.get(req);
                    const found = (cachedResponse) ? 'Found' : 'Not Found';
                     this.logger.debug('cache-interceptor', 'intercept', sub, availableSubs, `Cached response: ${found}`, '');
                }
            }
        }

        if (cachedResponse) {
            return of(cachedResponse);
        }

        return this.sendRequest(req, next, this.cache);
    }

    private skipCache(url: string): boolean {
        let skip = false;
        if (url) {
            skip = url.includes('cache=false');
        }
        return skip;
    }

    private isCachingUrl(cache: string[], url: string): boolean {
        let isCaching = false;
        let c = 0;
        while (c < cache.length) {
            if (url.includes(cache[c])) {
                isCaching = true;
                break;
            }
            c++;
        }
        return isCaching;
    }

    private sendRequest(req: HttpRequest<any>, next: HttpHandler, cache: CacheService): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                tap(event => {
                        if (this.useClientCaching === true) {
                            if (event instanceof HttpResponse) {
                                const isCaching = this.isCachingUrl(this.cachingUrls, req.url);
                                if (event.ok && isCaching) {
                                    cache.put(req, event);
                                }
                            }
                        }
                })
            );
    }
}
